import * as React from "react";

export function MoneyGotas(props) {
  return (
    <svg
      width={44}
      height={44}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.008 10.223S9.438 22.525 9.438 31.438C9.438 38.365 15.074 44 22 44c6.926 0 12.562-5.635 12.562-12.561 0-8.718-12.554-21.216-12.554-21.216zm3.59 18.053h-2.573a1.027 1.027 0 00-2.05 0c0 .506.367.927.85 1.01H22a3.603 3.603 0 013.599 3.6 3.604 3.604 0 01-2.312 3.36v2.15h-2.574v-2.15a3.604 3.604 0 01-2.312-3.36h2.574a1.027 1.027 0 002.05 0c0-.506-.367-.927-.85-1.011H22a3.603 3.603 0 01-3.599-3.599c0-1.531.962-2.841 2.312-3.36v-2.15h2.574v2.15a3.604 3.604 0 012.312 3.36zM39.14 4.273C37.715 2.343 35.35 0 35.35 0s-2.377 2.313-3.805 4.234c-2.002 2.696-3.017 5.079-3.017 7.083a6.82 6.82 0 006.813 6.813 6.82 6.82 0 006.814-6.813c0-1.964-1.015-4.334-3.015-7.044zM15.472 11.317c0-1.964-1.015-4.334-3.015-7.044C11.032 2.343 8.667 0 8.667 0S6.288 2.313 4.861 4.234C2.86 6.93 1.845 9.313 1.845 11.317a6.82 6.82 0 006.813 6.813 6.82 6.82 0 006.814-6.813z"
        fill="#FAFAFA"
      />
    </svg>
  );
}
